import { lazy } from "react"
import {
  ACL_READ,
  ACL_SUBJECT_PROFILE,
  ACL_UPDATE
} from "@configs/acl/constants"

const ProfileRoutes = [
  {
    path: "/profile",
    component: lazy(() => import("@views/profile")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_PROFILE
    }
  },
  {
    path: "/profile/register",
    component: lazy(() => import("@views/profile/ProfileEditor")),
    exact: true,
    meta: {
      action: ACL_UPDATE,
      resource: ACL_SUBJECT_PROFILE
    }
  },
  {
    path: "/profile/update",
    component: lazy(() => import("@views/profile/ProfileUpdate")),
    exact: true,
    meta: {
      action: ACL_UPDATE,
      resource: ACL_SUBJECT_PROFILE
    }
  },
  {
    path: "/profile/call-verify",
    component: lazy(() => import("@views/jitsi/Jitsi")),
    exact: true,
    meta: {
      action: ACL_UPDATE,
      resource: ACL_SUBJECT_PROFILE
    }
  }
]

export default ProfileRoutes
